export var PolicyDraftHandleEnum;

(function (PolicyDraftHandleEnum) {
  PolicyDraftHandleEnum["initialization"] = "initialization";
  PolicyDraftHandleEnum["previewPrice"] = "previewPrice";
  PolicyDraftHandleEnum["saveDraftDetail"] = "saveDraftDetail";
})(PolicyDraftHandleEnum || (PolicyDraftHandleEnum = {}));